(function () {
    'use strict';

    var module = angular.module("imApp");

    module.factory("ediDestinationsService", ['p2DataTaskService', function (p2DataTaskService) {
        var service = {
            loadP2EdiDestinationList: function () {
                return p2DataTaskService.call(987, {});
			}
        };

        return service;
    }]);
})();